import './OxylinkConnectHeader.scss';

import classNames from 'classnames';
import React from 'react';

import {
	ConnectHeader,
	ConnectHeaderFactory,
	ConnectHeaderProps,
} from '../../../../../libs/IdeLink.Web.Common/src/modules/Auth/Pages/components/ConnectHeader/ConnectHeader';

const OxylinkConnectHeader = ({ className = '', ...props }: ConnectHeaderProps) => {
	return (
		<ConnectHeader
			{...props}
			className={classNames('OxylinkConnectHeader-root', { [className]: className })}
		/>
	);
};

export const overrideOxylinkConnectHeader = () => {
	ConnectHeaderFactory.register('**', OxylinkConnectHeader);
};
